import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import { getUtmParams } from "@/common/utmParams";
var api__createAribOrder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(userInfo, postId) {
    var params, res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          params = _objectSpread(_objectSpread({
            id: postId,
            post_id: postId
          }, userInfo), getUtmParams());
          _context.p = 1;
          _context.n = 2;
          return fetcher(null, true).post('/finance/create-arib', params);
        case 2:
          res = _context.v;
          return _context.a(2, res || null);
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error("Error creating ARIB order:", _t);
          throw _t;
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function api__createAribOrder(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default api__createAribOrder;